<template>
    <div>
        <div class="container-fluid mt-2 mb-5">
            <!-- Patient and User Information -->
            <div class="row mb-3">
                <div class="col-md-6 text-start">
                    <p>
                        <strong>Médico:</strong> {{ currentUser?.displayName || 'No disponible' }} <br>
                    </p>
                </div>
                <div class="col-md-6 text-end">
                        🖨️<a class="text-center smallText"
                        href="#" @click.prevent="printNotaMedica">Imprimir nota médica</a>
                    </div>
            </div>

            <!-- Medical Note Information -->
            <div v-if="notaMedica" class="card">
                <div class="card-body">
                    <p>
                        <strong>Tipo de Nota:</strong> {{ notaMedica.tipo_nota }} <br>
                        <strong>Motivo de la Consulta:</strong> {{ notaMedica.motivo_consulta }} <br>
                        <div v-html="notaMedica.ficha_identificacion + notaMedica.signos_vitales + notaMedica.observaciones"></div>
                    </p>
                    <p>
                        <strong>Exploración Física:</strong> {{ notaMedica.exploracion_fisica || 'No disponible' }} <br>
                        <strong>Estudios Solicitados:</strong> {{ notaMedica.estudios_solicitados || 'No disponible' }} <br>
                        <strong>Diagnóstico:</strong> {{ notaMedica.diagnostico }} <br>
                        <strong>Evolución del Paciente:</strong> {{ notaMedica.evolucion_paciente || 'No disponible' }} <br>
                        <strong>Tratamiento:</strong> {{ notaMedica.tratamiento || 'No disponible' }} <br>
                        <strong>Pronóstico:</strong> {{ notaMedica.pronostico || 'No disponible' }} <br>
                    </p>
                 
                </div>
                <div class="card-footer text-muted">
                    <p>
                        <strong>Creado en:</strong> {{ formatDate(notaMedica.creado_en) }}
                    </p>
                </div>
            </div>
            <div v-else class="text-center">
                <p>Cargando información de la nota médica...</p>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "VerNotaMedica",
        props: {
            nota_medica_id: {
                type: Number,
                required: true
            },
            currentUser: {
                type: Object,
                required: true
            },
            paciente: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                notaMedica: null
            };
        },
        methods: {
            async printNotaMedica() {
                try {
                    this.openLoading();
                    this.notaMedica.displayName = this.currentUser?.displayName || 'No disponible';
                    this.notaMedica.paciente = this.paciente;

                    this.notaMedica.observacionesFinales = `${this.notaMedica.ficha_identificacion || ''} ${this.notaMedica.signos_vitales || ''} ${this.notaMedica.observaciones || ''}`;

                    const response = await axios.post(`${API}/imprimir-notaMedica`, this.notaMedica);

                    if (response.data.status === 'success') {
                        this.closeLoading();
                        await this.callAudit(this.currentUser?.mainId,"IMPRESION","notas_medicas",this.notaMedica.id,"Impresión de nota médica");


                        const pdfUrl = `${API}${response.data.pdfUrl}`;

                        // Verificar si es un dispositivo móvil
                        if (this.isMobileDevice()) {
                            // En móvil, abrir en una nueva pestaña
                            window.open(pdfUrl, '_blank');
                            this.notify('info', 'El PDF se abrirá en una nueva pestaña.');
                        } else {

                            const modal = document.createElement("div");
                            modal.style.position = "fixed";
                            modal.style.top = "0";
                            modal.style.left = "0";
                            modal.style.width = "100%";
                            modal.style.height = "100%";
                            modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
                            modal.style.display = "flex";
                            modal.style.justifyContent = "center";
                            modal.style.alignItems = "center";
                            modal.style.zIndex = "1051";

                            const iframe = document.createElement("iframe");
                            iframe.src = pdfUrl;
                            iframe.style.width = "80%";
                            iframe.style.height = "80%";
                            iframe.style.border = "2px solid white";
                            iframe.style.borderRadius = "10px";

                            const closeButton = document.createElement("span");
                            closeButton.textContent = "✖";
                            closeButton.style.position = "absolute";
                            closeButton.style.top = "20px";
                            closeButton.style.right = "20px";
                            closeButton.style.color = "white";
                            closeButton.style.fontSize = "24px";
                            closeButton.style.cursor = "pointer";
                            closeButton.addEventListener("click", () => {
                                document.body.removeChild(modal);
                            });

                            modal.appendChild(iframe);
                            modal.appendChild(closeButton);
                            document.body.appendChild(modal);
                        }
                    } else {
                        this.closeLoading();
                        this.$emit('error', 'Error al generar la nota médica.');
                    }
                } catch (error) {
                    this.closeLoading();
                    console.error(error);
                    this.$emit('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
            async fetchNotaMedica() {
                try {
                    const response = await axios.get(`${API}/nota_medica/${this.nota_medica_id}`);
                    if (response.data.status === 'success') {
                        this.notaMedica = response.data.data;
                    } else {
                        this.$emit('error', response.data.message);
                    }
                } catch (error) {
                    console.error(error);
                    this.$emit('error', 'Error al cargar la nota médica.');
                }
            },
            formatDate(date) {
                const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
                return new Date(date).toLocaleDateString('es-ES', options);
            }
        },
        mounted() {
            this.fetchNotaMedica();
        }
    };
</script>

<style>
    .card {
        margin-top: 20px;
    }
    .card-body p {
        line-height: 1.6;
    }
    .card-body strong {
        font-weight: 600;
    }
    .card-footer {
        font-size: 0.9rem;
    }
</style>
